export function getAgentSourceType(fallback = 'ip_drafting'): string {
    const hash = window.location.hash; // e.g. "#/?agent=disclosure"
    const queryString = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '';
    const params = new URLSearchParams(queryString);
    const agent = params.get('agent');
    return agent ? `ip_drafting_${agent}` : fallback;
}
